import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { companyInfo, services } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src="/greva-logo.svg" 
                alt="Greva Electric Logo" 
                className="h-20 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-4">
              Professional electrical services in Saskatoon, SK. Specializing in commercial, residential, and fire alarm systems.
            </p>
            <div className="space-y-2">
              <a href={`tel:${companyInfo.phone}`} className="flex items-center text-gray-300 hover:text-teal-400 transition-colors">
                <Phone className="mr-2" size={18} />
                {companyInfo.phone}
              </a>
              <a href={`mailto:${companyInfo.email}`} className="flex items-center text-gray-300 hover:text-teal-400 transition-colors">
                <Mail className="mr-2" size={18} />
                {companyInfo.email}
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.id}>
                  <button
                    onClick={() => scrollToSection('services')}
                    className="text-gray-300 hover:text-teal-400 transition-colors"
                  >
                    {service.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-300 hover:text-teal-400 transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-teal-400 transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-teal-400 transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-gray-300 hover:text-teal-400 transition-colors">
                  Reviews
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 text-center">
          <p className="text-gray-300 text-lg mb-2">
            For more information about us and our services please email:
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-6 mb-6">
            <a 
              href={`mailto:${companyInfo.email}`}
              className="text-teal-400 hover:text-teal-300 font-semibold text-lg transition-colors"
            >
              {companyInfo.email}
            </a>
            <span className="hidden sm:inline text-gray-500">or</span>
            <a 
              href={`tel:${companyInfo.phone}`}
              className="text-teal-400 hover:text-teal-300 font-semibold text-lg transition-colors"
            >
              call {companyInfo.phone}
            </a>
          </div>
          <p className="text-gray-400">
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;